"use client";

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import { GenericPartnerCard } from "./GenericPartnerCard";
import { PartnerMaifCard } from "./PartnerMaifCard";
import { PARTNERS } from "./partners.config";
export function PartnersSection() {
  const $ = _c(7);
  const t = useTranslations("contact");
  let t0;
  if ($[0] !== t) {
    t0 = t("partners.title");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <h3 className="text-2xl font-serif text-forest-green text-center mb-12">{t0}</h3>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="grid grid-cols-1 md:grid-cols-5 gap-8 items-center justify-items-center">{PARTNERS.filter(_temp).map(_temp2)}<PartnerMaifCard /></div>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1) {
    t3 = <>{t1}{t2}</>;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function _temp2(partner) {
  return <GenericPartnerCard key={partner.id} {...partner} />;
}
function _temp(p) {
  return p.active;
}